export var decideContainerSwitch = function (_a) {
    var target = _a.target, selectedRef = _a.selectedRef, containers = _a.containers, packerById = _a.packerById, currentUserPartyId = _a.currentUserPartyId, openStatusId = _a.openStatusId, resolveRootId = _a.resolveRootId;
    if (target && currentUserPartyId) {
        var targetContainer = containers.find(function (c) { return c.containerId === target.containerId; });
        if (targetContainer && targetContainer.statusId === openStatusId) {
            var packer = packerById === null || packerById === void 0 ? void 0 : packerById[target.containerId];
            if ((packer === null || packer === void 0 ? void 0 : packer.packerPartyId) && packer.packerPartyId !== currentUserPartyId) {
                return { action: 'warn', reason: 'other-packer', packerName: packer.packerName || packer.packerPartyId };
            }
        }
    }
    // No current selection — nothing to interrupt.
    if (!selectedRef)
        return { action: 'allow' };
    var selectedRootId = resolveRootId(selectedRef);
    if (!selectedRootId)
        return { action: 'allow' };
    // Allow moving away from a closed root.
    var selectedRoot = containers.find(function (c) { return c.containerId === selectedRootId; });
    if (!selectedRoot || selectedRoot.statusId !== openStatusId)
        return { action: 'allow' };
    // Allow moving between children of the same open root.
    if (target && resolveRootId(target) === selectedRootId)
        return { action: 'allow' };
    return { action: 'warn', reason: 'source-open' };
};
